import React from 'react';
import { Box, Flex, Text, Center, Spinner } from '@chakra-ui/react';
import { TextG14, TextG16 } from '../typography';
import dayjs from 'dayjs';

export interface MembershipReferral {
  id: number;
  handle?: string;
  name: string;
  redeemed_at: string;
  is_rewarded: number;
  // For backward compatibility with mock data
  email?: string;
  created_at?: string;
}

interface ReferralsListProps {
  referrals: MembershipReferral[];
  isLoading?: boolean;
  emptyMessage?: string;
}

const ReferralsList: React.FC<ReferralsListProps> = ({ 
  referrals, 
  isLoading = false,
  emptyMessage = "You haven't invited any friends yet." 
}) => {
  if (isLoading) {
    return (
      <Center py={5}>
        <Spinner size="md" />
      </Center>
    );
  }

  if (!referrals || referrals.length === 0) {
    return (
      <Box textAlign="center" py={4}>
        <TextG16>{emptyMessage}</TextG16>
        <TextG14 color="gray.500" mt={2}>
          Share your invitation code and earn free months!
        </TextG14>
      </Box>
    );
  }

  return (
    <Box>
      <TextG16 mb={4}>
        You've had <span style={{color: 'blue', fontWeight: 500}}>{referrals.length}</span> friends accept your
        invitation to Local Insiders Club and earned
        <span style={{color: 'blue', fontWeight: 500}}> {referrals.length}</span> free months!
      </TextG16>

      <Box>
        {referrals.map((referral, index) => (
          <Flex
            key={referral.id || index}
            justify="space-between"
            align="center"
            p={3}
            borderBottomWidth={index !== referrals.length - 1 ? '1px' : '0'}>
            <TextG14>{referral.name || referral.handle || referral.email || 'Friend'}</TextG14>
            <TextG14>{dayjs(referral.redeemed_at || referral.created_at).format('MMM D, YYYY')}</TextG14>
          </Flex>
        ))}
      </Box>
    </Box>
  );
};

export default ReferralsList;